<template>
  <layout-blank2>
    <slot></slot>
  </layout-blank2>
</template>

<script>
import LayoutBlank2 from '@/@core/layouts/variants/blank/LayoutBlank2.vue'

export default {
  components: {
    LayoutBlank2,
  },
}
</script>

<style>
</style>
